module.exports = __webpack_public_path__ + "static/strangers-to-ourselves-bfce632b3ac838c488118491cb98e663.jpg";